import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Image from '../../atoms/Image';
import stampCover from '../../../assets/images/stamp_cover.png';

const Wrapper = styled.div`
  position: relative;
  border-radius: 50%;
`;

const ImageCover = styled(Image)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

const Stamp = ({ src, size, stamped, ...props }) => {
  return (
    <Wrapper>
      <Image src={src} width={size} circle {...props} />
      {stamped && (
        <ImageCover src={stampCover} width={size} circle {...props} />
      )}
    </Wrapper>
  );
};

Stamp.propTypes = {
  src: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stamped: PropTypes.bool,
};

Stamp.defaultProps = {
  src: null,
  size: undefined,
  stamped: false,
};

export default Stamp;
